/* ============
 * Actions for the formalities module
 * ============
 *
 * The actions that are available on the
 * formalities module.
 */
import axios from 'axios'

import { mapWorkflowBanksToSelectItems } from '@/utils/workflow-banks'

export default {
  registerFormality ({ commit, dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'requirements', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  registerRequirements ({ commit, dispatch }, item) {
    let api = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'requirements', item)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  registerFormalityModifyAccount ({ commit, dispatch }, item) {
    let api = process.env.REQUIREMENT_API_URL;
    
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        // Create FormData object
        const formData = new FormData();
        
        // Add the JSON as a string to the 'request' field
        formData.append('request', JSON.stringify(item));
        
        // Configure axios to send form data
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        
        axios
          .post(api + '/public-zone/request-management', formData, config)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      }).catch(err => {
        reject(err);
      });
    });
  },
  registerFiles ({ commit, dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'requirements/files', item, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  },
  sendMailConstancy ({ commit, dispatch }, data) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.post(api + 'requirements/sendmail', data)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getBeneficiariosPoliza ({ commit, dispatch }, data) {
    let api = process.env.API_RVIADM
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'polizas/beneficiarios/' + data.codCartera + '/' + data.codPoliza + '/' + data.usuario)
          .then(res => resolve(res))
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getFrequency ({ dispatch }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'policies/info/payment-frequencies/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getWildcardFees ({ dispatch }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'policies/info/wildcard-installments/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  /**
   * Lista bancos activos desde API Sistemas Workflow (público, sin JWT).
   * @returns {Promise<Array<{ text: string, value: string, email: string }>>}
   */
  async fetchWorkflowBanks () {
    // const base = String(process.env.API_SISTEMAS_WORKFLOW_URL || '').replace(/\/$/, '')
    const base = String(process.env.API_URL || '').replace(/\/$/, '')

    const url = `${base}/workflow/banks`

    const res = await axios.get(url)

    const rows = res.data

    return mapWorkflowBanksToSelectItems(rows)
  },

  /**
   * Verifica si el PDF de la poliza existe
   */
  async checkPdfPoliza (context, { numPoliza, codProceso }) {
    for (let x = 0; x < codProceso.length; x++) {
      try {
        const res = await axios.get('policies/processes/' + codProceso[x] + '/electronic-documents/' + numPoliza)
        const data = res.data

        const isPdf = typeof data === 'string' && data.trim().startsWith('%PDF-')

        if (res.status === 200 && isPdf) {
          return true
        }
      } catch (error) {
        console.warn('warn checking pdf', error)
        // importante: NO cortar el loop
      }
    }

    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/formalities/actions.js